module.exports = __webpack_public_path__ + "img/mfa.be2215a.svg";